
import userLogo from "../assets/user.png";
import logo from "../assets/logo.png";
import { LuLogOut } from "react-icons/lu";
import { HiMenu, HiX } from "react-icons/hi";
import { useNavigate, useLocation } from "react-router-dom";
import useAuth from "../useAuth";

export default function Header({ isSidebarOpen, setIsSidebarOpen }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    const confirmed = window.confirm("Are you sure you want to Log Out?");
    if (!confirmed) return;
    logout();
  };


  const isActive = (path) => location.pathname === path;

  return (
    <header className="flex items-center justify-between px-4 md:px-8 py-3 md:py-4 bg-white/80 backdrop-blur-md border-b border-slate-200 sticky top-0 z-50">
      {/* Left: Mobile Toggle & Logo */}
      <div className="flex items-center gap-2 md:gap-3">
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="lg:hidden p-2 rounded-xl text-slate-600 hover:bg-slate-100 transition-all"
        >
          {isSidebarOpen ? <HiX size={24} /> : <HiMenu size={24} />}
        </button>

        <div
          className="flex items-center gap-3 cursor-pointer group shrink-0"
          onClick={() => navigate("/my/home")}
        >
          <div className="w-32 md:w-48 bg-white rounded-lg flex items-center justify-center transition-all">
            <img src={logo} alt="Logo" className="w-full" />
          </div>
        </div>
      </div>


      {/* Right: Actions */}
      <div className="flex items-center gap-4">

        <div className="flex items-center gap-2">


          {/* Profile */}
          <div className="relative group ml-1">
            <div
              onClick={() => navigate("./profile")}
              className="w-10 h-10 cursor-pointer transition-all hover:scale-105 active:scale-95 group/avatar"
            >
              <div
                className="w-full h-full bg-gradient-to-br from-indigo-600 to-violet-700 flex items-center justify-center text-white font-black text-xs shadow-lg shadow-indigo-100 transition-all border-2 border-white rounded-full"
              >
                {user?.fullName?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) || "--"}
              </div>
            </div>

            {/* Dropdown */}
            <div className="absolute right-0 mt-3 w-56 bg-white rounded-2xl border border-slate-200 shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 overflow-hidden z-[110]">
              <div className="px-5 py-4 border-b border-slate-100">
                <p className="text-slate-900 font-bold text-sm truncate">{user?.fullName}</p>
                <p className="text-slate-500 text-xs truncate">{user?.email || "user@example.com"}</p>
              </div>
              <div className="p-2">
                <button
                  onClick={() => navigate("./profile")}
                  className="w-full text-left px-4 py-2.5 text-sm text-slate-600 hover:text-slate-900 hover:bg-slate-50 rounded-xl transition-all"
                >
                  Profile Settings
                </button>
                <button
                  onClick={handleLogout}
                  className="w-full text-left px-4 py-2.5 text-sm text-[#F43F5E] hover:bg-[#F43F5E]/5 rounded-xl transition-all flex items-center gap-2 mt-1"
                >
                  <LuLogOut size={16} />
                  Sign out
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
